// epics.js
import { combineEpics, ofType } from "redux-observable";
import { mergeMap, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  userRequest,
  userSuccess,
  userFailure,
  changePasswordRequest,
  changePasswordSuccess,
  changePasswordFailure,
  getUserDetailsRequest,
  getUserDetailsSuccess,
  getUserDetailsFailure,
  userImageUploadRequest,
  userImageUploadSuccess,
  userImageUploadFailure,
  userUpdateRequest,
  userUpdateSuccess,
  userUpdateFailure,
  userImageDeleteRequest,
  userImageDeleteSuccess,
  userImageDeleteFailure,
  favoriteUserProfilesRequest,
  favoriteUserProfilesSuccess,
  favoriteUserProfilesFailure,
  markProfileAsFavoriteRequest,
  markProfileAsFavoriteSuccess,
  markProfileAsFavoriteFailure,
  unMarkProfileAsFavoriteRequest,
  unMarkProfileAsFavoriteSuccess,
  unMarkProfileAsFavoriteFailure
} from "./user";
import {
  observablePOST,
  observableGET,
  observablePUT,
  observableDELETE
} from "@/api/apiClient";
import { hideModal } from "@/store/slices/modalSlice";

// user Epic
const fetchDataUserEpic = (action$) =>
  action$.pipe(
    ofType(userRequest.type),
    mergeMap((action) => {
      const { userId } = action.payload;

      return observableGET(`/users/user-by-uuid/${userId}`).pipe(
        // TODO: handle success
        mergeMap((response) => of(userSuccess(response.data))),
        catchError((error) => of(userFailure(error)))
      );
    })
  );

// user update
const updateDataUserEpic = (action$) =>
  action$.pipe(
    ofType(userUpdateRequest.type),
    mergeMap((action) => {
      const loginUserId = localStorage.getItem("userId");
      return observablePUT(`/users`, {
        body: {
          ...action.payload
        }
      }).pipe(
        // TODO: handle success
        mergeMap((response) =>
          of(
            userUpdateSuccess(response.data),
            userRequest({ userId: loginUserId })
          )
        ),
        catchError((error) => of(userUpdateFailure(error)))
      );
    })
  );

const fetchDataChangePasswordEpic = (action$) =>
  action$.pipe(
    ofType(changePasswordRequest.type),
    mergeMap((action) => {
      return observablePOST(`/users/change-password`, {
        body: {
          ...action.payload
        }
      }).pipe(
        // TODO: handle success
        mergeMap((response) =>
          of(changePasswordSuccess(response.data), hideModal())
        ),
        catchError((error) => of(changePasswordFailure(error)))
      );
    })
  );
const fetchDataUserDetailsEpic = (action$) =>
  action$.pipe(
    ofType(getUserDetailsRequest.type),
    mergeMap((action) => {
      const { userId } = action.payload;
      return observableGET(`/users/user-by-uuid/${userId}`).pipe(
        mergeMap((response) => of(getUserDetailsSuccess(response.data))),
        catchError((error) => of(getUserDetailsFailure(error)))
      );
    })
  );

const uploadUserProfileImageEpic = (action$) =>
  action$.pipe(
    ofType(userImageUploadRequest.type),
    mergeMap((action) => {
      const { userId, selectedImage } = action.payload;
      return observablePOST(`/users/upload-profile-picture/${userId}`, {
        body: selectedImage
      }).pipe(
        mergeMap((response) => of(userImageUploadSuccess(response.data))),
        catchError((error) => of(userImageUploadFailure(error)))
      );
    })
  );

const deleteUserImageEpic = (action$) =>
  action$.pipe(
    ofType(userImageDeleteRequest.type),
    mergeMap((action) => {
      const { uuid } = action.payload;
      return observableDELETE(`/users/delete-profile-picture/${uuid}`).pipe(
        mergeMap(() => {
          return of(userImageDeleteSuccess());
        }),
        catchError((error) => {
          return of(userImageDeleteFailure(error));
        })
      );
    })
  );

const fetchDataFavoriteUserProfilesEpic = (action$) =>
  action$.pipe(
    ofType(favoriteUserProfilesRequest.type),
    mergeMap((action) => {
      const { params } = action.payload;
      return observableGET(`/favourite-user-profile`, { params }).pipe(
        mergeMap((response) => {
          const { favouriteUserProfileResponses, totalPages } = response.data;
          return of(
            favoriteUserProfilesSuccess({
              favouriteUserProfileResponses,
              totalPages,
              currentPage: params?.page
            })
          );
        }),
        catchError((error) => of(favoriteUserProfilesFailure(error)))
      );
    })
  );
const markProfileAsFavoriteEpic = (action$) =>
  action$.pipe(
    ofType(markProfileAsFavoriteRequest.type),
    mergeMap((action) => {
      const { userProfileId, notApiCalled } = action.payload;
      if (!notApiCalled) {
        return observablePOST(`/favourite-user-profile/${userProfileId}`).pipe(
          mergeMap(() => {
            return of(markProfileAsFavoriteSuccess({ userProfileId }));
          }),
          catchError((error) => {
            return of(
              markProfileAsFavoriteFailure(error),
              unMarkProfileAsFavoriteRequest({
                userProfileId,
                notApiCalled: true
              })
            );
          })
        );
      }
    })
  );

const unMarkProfileAsFavoriteEpic = (action$) =>
  action$.pipe(
    ofType(unMarkProfileAsFavoriteRequest.type),
    mergeMap((action) => {
      const { userProfileId, notApiCalled } = action.payload;
      if (!notApiCalled) {
        return observableDELETE(
          `/favourite-user-profile/${userProfileId}`
        ).pipe(
          mergeMap(() => {
            return of(unMarkProfileAsFavoriteSuccess({ userProfileId }));
          }),
          catchError((error) => {
            return of(
              unMarkProfileAsFavoriteFailure(error),
              markProfileAsFavoriteEpic({
                userProfileId,
                notApiCalled: true
              })
            );
          })
        );
      }
    })
  );

const userEpic = combineEpics(
  fetchDataUserEpic,
  fetchDataChangePasswordEpic,
  fetchDataUserDetailsEpic,
  uploadUserProfileImageEpic,
  updateDataUserEpic,
  deleteUserImageEpic,
  fetchDataFavoriteUserProfilesEpic,
  markProfileAsFavoriteEpic,
  unMarkProfileAsFavoriteEpic
);

export default userEpic;
